module.exports = __webpack_public_path__ + "img/public/SiteIcons/instantIconNew.svg?1ed940b5";